import React from "react";
import { Card, Image } from "semantic-ui-react";
import PropTypes from "prop-types";

const CategoryCard = card => {
    const attribute = card.target ? "_blank" : null;
    return (
        <Card href={card.link} target={attribute}>
            <Image src={card.icon} wrapped ui={false} />
            <Card.Content>
                <Card.Header>{card.category}</Card.Header>
                {card.creator ? (
                    <Card.Meta>Creator: {card.creator}</Card.Meta>
                ) : null}
                <Card.Description>{card.desc}</Card.Description>
                {card.demo ? (
                    <Card.Meta as={"a"} href={card.demo}>
                        How to play
                    </Card.Meta>
                ) : null}
            </Card.Content>
        </Card>
    );
};

const CategoryPage = ({ categories }) => {
    return (
        <Card.Group itemsPerRow={4}>
            {categories.map(f => {
                return CategoryCard(f);
            })}
        </Card.Group>
    );
};

CategoryPage.propTypes = {
    categories: PropTypes.array.isRequired
};

export default CategoryPage;
